import { render, staticRenderFns } from "./PersonalSettings.vue?vue&type=template&id=3c314c2b&scoped=true"
import script from "./PersonalSettings.vue?vue&type=script&lang=js"
export * from "./PersonalSettings.vue?vue&type=script&lang=js"
import style0 from "./PersonalSettings.vue?vue&type=style&index=0&id=3c314c2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c314c2b",
  null
  
)

export default component.exports